import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, } from 'react-bootstrap';
import Select from 'react-select';
import { ChooseComponent, useFetch, useTranslation, usePermission } from '@np/np_webcomponentlib'

import { API_OPERATIONS } from '../../shared/consts/api'

import { EntityType, DataEntityType, EntityFormPropsWithType, initEntity, columnsIdrfspecification, columnsIdrfcharacteristictype, optionsEnumStatusDoc, TypeStatusEnum } from './OperationTypes'


// import { ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'






export const OperationForm = ({ title, idInit, handleClose, initEntityProps }: EntityFormPropsWithType) => {

    const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('$component_name');

    const [currentID, setCurrentID] = useState<string | null>(idInit)
    const [status, setStatus] = useState<TypeStatusEnum | undefined>(undefined)

    useEffect(() => {
        setCurrentID(idInit)
    }, [idInit])

    const [, doFetchPatchStatus] = useFetch(
        `${API_OPERATIONS}operation/status`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }

    const [, doFetchForcedStatus] = useFetch(
        `${API_OPERATIONS}operation/forcedstatus`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }



    const handleSave = () => {
        
        if (!currentID)
        {return}

        if (!status)
            {return}


        var method = "PATCH"

        const inputData = {
            "idOperation": currentID,
            "status": status
        }

        
        doFetchPatchStatus({
            method: method,
            "Content-Type": "application/json",
            data: inputData
        }).then(responce => {
            console.log("responce.result.status", responce.result.status)
            if (responce.result.status === "success") {
                handleClose();
            }
            console.log(responce.data)
        })


    }

    const handleFroced = () => {
        
        if (!currentID)
            {return}


        var method = "POST"

        const inputData = [currentID]

        
        doFetchForcedStatus({
            method: method,
            "Content-Type": "application/json",
            data: inputData
        }).then(responce => {
            console.log("responce.result.status", responce.result.status)
            if (responce.result.status === "success") {
                handleClose();
            }
            console.log(responce.data)
        })


    }


    const createButtonTitle = useTranslation('createButton')
    const updateButtonTitle = useTranslation('updateButton')


    return (<Card>
        <Card.Header>
            <Card.Title as='h4'>{title}</Card.Title>
        </Card.Header>
        <Card.Body className="">
            {/* <Form className="form-horizontal"> */}

            {/* <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('client')}</Form.Label>
                <Col md={9}>




                </Col>
            </Row> */}

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('newStatus')}</Form.Label>
                <Col md={9}>
                    <Select options={optionsEnumStatusDoc} placeholder='choose one' classNamePrefix='Select' value={optionsEnumStatusDoc.find(option => option.value === status) ?? optionsEnumStatusDoc[0]}
                        onChange={e => setStatus(e!.value)} />
                </Col>
            </Row>

            {canUpdate && currentID !== "" &&
                    <Button onClick={() => { handleSave(); }}> {updateButtonTitle} </Button>
            }


<Row className="mb-4">
                <Form.Label className="col-md-3">Принудительный успех</Form.Label>
                <Col md={9}>
                    {canUpdate && currentID !== "" &&
                    <Button onClick={() => { handleFroced(); }}> В успех </Button>
            }
                </Col>
            </Row>
            


        </Card.Body>
    </Card>)
}
